(() => {
  const config = document.querySelector('[data-anitials-pack-checkout]');
  const codes = Object.values(JSON.parse(config?.dataset.packCodes || '{}')).map(code => code.toLowerCase());
  if (!codes.length) return;
  const packNames = ['pack de sudaderas anitials', 'pack de jerséis anitials', 'pack de camisetas anitials', 'pack de sudaderas zippers anitials'];
  const observed = new WeakSet();
  let consentBanner;
  const reserveConsentSpace = () => {
    const cart = document.querySelector('#cart-drawer');
    if (!cart) return;
    const banner = document.querySelector('#tinycookie-wrapper');
    const rect = banner?.getBoundingClientRect();
    const cartRect = {left: innerWidth - cart.offsetWidth, right: innerWidth};
    const overlaps = rect?.height > 0 && rect.right > cartRect.left && rect.left < cartRect.right && rect.bottom > innerHeight - 40;
    const height = overlaps ? Math.max(0, Math.min(innerHeight - 160, innerHeight - rect.top)) : 0;
    const value = `${height}px`;
    if (cart.style.getPropertyValue('--anitials-pack-cookie-height') !== value) {
      cart.style.setProperty('--anitials-pack-cookie-height', value);
    }
  };
  const consentSize = new ResizeObserver(reserveConsentSpace);
  const observeConsent = () => {
    const banner = document.querySelector('#tinycookie-wrapper');
    if (banner !== consentBanner) {
      consentSize.disconnect();
      consentBanner = banner;
      if (banner) consentSize.observe(banner);
    }
    reserveConsentSpace();
  };
  const sync = cart => {
    cart.querySelectorAll('[data-cart-item]').forEach(item => {
      const meta = item.querySelector('.cart__item__meta');
      if (packNames.some(name => meta?.textContent.toLowerCase().includes(name))) {
        item.setAttribute('data-anitials-pack-item', '');
      }
    });
    const hasPack = !!cart.querySelector('[data-anitials-pack-item]');
    cart.toggleAttribute('data-anitials-pack-cart', hasPack);
    cart.querySelectorAll('.cart__discount, [data-discount-body]').forEach(row => {
      const text = row.textContent.toLowerCase();
      const isPackDiscount = hasPack && (codes.some(code => text.includes(code)) || packNames.some(name => text.includes(name)));
      row.toggleAttribute('data-anitials-pack-discount', isPackDiscount);
    });
    const body = cart.querySelector('[data-cart-drawer-body]');
    if (hasPack && body) body.setAttribute('tabindex', '0');
    reserveConsentSpace();
  };
  const setup = () => {
    document.querySelectorAll('cart-items').forEach(cart => {
      sync(cart);
      if (observed.has(cart)) return;
      observed.add(cart);
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; sync(cart); });
      }).observe(cart, {childList: true, subtree: true, characterData: true});
    });
  };
  setup();
  observeConsent();
  new MutationObserver(observeConsent).observe(document.body, {childList: true});
  window.addEventListener('resize', reserveConsentSpace, {passive: true});
  document.addEventListener('theme:cart:open', reserveConsentSpace);
  document.addEventListener('shopify:section:load', setup);
})();

